import { render, staticRenderFns } from "./orderPanel.vue?vue&type=template&id=19a4905c&scoped=true"
import script from "./orderPanel.vue?vue&type=script&lang=js"
export * from "./orderPanel.vue?vue&type=script&lang=js"
import style0 from "./orderPanel.vue?vue&type=style&index=0&id=19a4905c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4905c",
  null
  
)

export default component.exports